import { Vue, Prop, Emit, Component } from "vue-property-decorator";

@Component({
    components: {
        name: CourseExpire
    }
})
export default class CourseExpire extends Vue {
    @Prop() readonly expiredInfo: any;
    handleBuyCourse() {
        window.location.href =
            window.origin + "/order/" + this.expiredInfo.productId;
    }
    handleBuyCourseClose() {
        this.$set(this.expiredInfo, "showCloseIcon", false);
    }
}
//@ts-ignore
export { default as CourseExpire } from "./index.vue";
